export const decodeHtmlString = (html: string) => {
  const parser = new DOMParser().parseFromString(html, "text/html");

  return parser.documentElement.textContent || "";
};

export const removeParantheses = (value: string) => {
  if (!value.includes("(")) return value;

  return value.split("(")[0].trim();
};

export const cleanTipTopfFilterLabel = (value: string) => {
  return removeParantheses(decodeHtmlString(value));
};
